import React from 'react';
import { Helmet } from 'react-helmet-async';
import { FiArrowRight } from 'react-icons/fi';
import config from '../config';
import '../styles/CV.css';
import { Link } from 'react-router-dom';
import CVNavigation from '../components/CVNavigation';
import GeneralInfo from '../components/GeneralInfo';
import EducationItem from '../components/EducationItem';
import SkillsSection from '../components/SkillsSection';
import ProjectCard from '../components/ProjectCard';
import SocialLinks from '../components/SocialLinks';
import SectionHeader from '../components/SectionHeader';

function CV() {
  return (
    <div className="portfolio cv-container">
      <Helmet>
        <title>Devang Saraogi — CV</title>
        <meta name="description" content="CV of Devang Saraogi — Education, work experience, technical skills, projects, and achievements in Machine Learning and Software Engineering." />
        <link rel="canonical" href="https://devangsaraogi.github.io/cv" />
      </Helmet>
      <div className="portfolio-left">
        <header>
          <div className="top-content">
            <div className="header-content">
              <div className="cv-profile-photo">
                <img src="/images/profile.jpg" alt={config.personalInfo.name} width={150} height={115} />
              </div>
              <h1>
                <Link to="/" className="name-link">
                  {config.personalInfo.name}
                </Link>
              </h1>
              <h2>{config.personalInfo.title} · {config.personalInfo.location}</h2>
            </div>
            <CVNavigation />
          </div>
          <div className="bottom-content">
            <SocialLinks />
          </div>
        </header>
      </div>

      <div className="portfolio-right">
        <section id="general" className="cv-section">
          <SectionHeader title="GENERAL INFORMATION" linkTo="/" linkLabel="BACK" />
          <GeneralInfo personalInfo={config.personalInfo} />
        </section>

        <section id="education" className="cv-section">
          <SectionHeader title="EDUCATION" linkTo="/" linkLabel="BACK" />
          {config.personalInfo.education.map((edu, index) => (
            <EducationItem key={index} education={edu} />
          ))}
        </section>

        <section id="skills" className="cv-section">
          <SectionHeader title="SKILLS" linkTo="/" linkLabel="BACK" />
          <div className="cv-content">
            <SkillsSection skills={config.technicalSkills} />
          </div>
        </section>

        <section id="industry" className="cv-section">
          <SectionHeader title="INDUSTRY EXPERIENCE" linkTo="/" linkLabel="BACK" />
          <div className="cv-content">
            {config.experiences
              .filter(exp => exp.type === "industry")
              .map((exp, index) => (
                <div key={index} className="experience-item">
                  <div className="date">{exp.date}</div>
                  <div className="role-details">
                    <h3>
                      {exp.role} · {exp.company}
                    </h3>
                    <p className="company">{exp.location}</p>
                    <p className="description">{exp.description}</p>
                    <ul className="cv-skills">
                      {exp.skills.map((skill, i) => (
                        <li key={i}>{skill}</li>
                      ))}
                    </ul>
                  </div>
                </div>
            ))}
          </div>
        </section>

        <section id="research" className="cv-section">
          <SectionHeader title="RESEARCH EXPERIENCE" linkTo="/" linkLabel="BACK" />
          <div className="cv-content">
            {config.experiences
              .filter(exp => exp.type === "research")
              .map((exp, index) => (
                <div key={index} className="experience-item">
                  <div className="date">{exp.date}</div>
                  <div className="role-details">
                    <h3>
                      {exp.role} · {exp.company}
                    </h3>
                    <p className="company">{exp.location}</p>
                    <p className="description">{exp.description}</p>
                    <ul className="cv-skills">
                      {exp.skills.map((skill, i) => (
                        <li key={i}>{skill}</li>
                      ))}
                    </ul>
                  </div>
                </div>
            ))}
          </div>
        </section>

        <section id="projects" className="cv-section">
          <SectionHeader title="PROJECTS" linkTo="/" linkLabel="BACK" />
          <div className="projects-grid">
            {config.projects.slice(0, 3).map((project, index) => (
              <ProjectCard key={index} project={project} />
            ))}
          </div>
          <Link to="/archive" className="view-archive">
            View Project Archive <FiArrowRight className="title-arrow title-arrow-right" />
          </Link>
        </section>

        <section id="achievements" className="cv-section">
          <SectionHeader title="ACHIEVEMENTS" linkTo="/" linkLabel="BACK" />
          <div className="cv-content">
            {config.achievements.map((item, index) => (
              <div key={index} className="experience-item">
                <div className="date">{item.date}</div>
                <div className="role-details">
                  <h3>{item.title}</h3>
                  <p className="description">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section id="volunteering" className="cv-section">
          <SectionHeader title="VOLUNTEERING" linkTo="/" linkLabel="BACK" />
          <div className="cv-content">
            {config.volunteering.map((vol, index) => (
              <div key={index} className="experience-item">
                <div className="date">{vol.date}</div>
                <div className="role-details">
                  <h3>
                    {vol.role} · {vol.course}
                  </h3>
                  <p className="company">{vol.institution} · {vol.location}</p>
                  <p className="description">{vol.description}</p>
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}

export default CV; 